import { render, staticRenderFns } from "./User_Details.vue?vue&type=template&id=6c0956a8&"
import script from "./User_Details.vue?vue&type=script&lang=js&"
export * from "./User_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports